(() => {
    'use strict';

    angular
        .module('uwAgenda.email')
        .controller(
            'AlreadyInIntegrationWarningModalController',
            ['$uibModalInstance', AlreadyInIntegrationWarningModalControllerFn]);

    function AlreadyInIntegrationWarningModalControllerFn($uibModalInstance) {
        const vm = this;

        vm.confirm = function () {
            $uibModalInstance.close();
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();